import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/case-studies/legal-translation/page.tsx");
